<template>
    <div>
        <action
            @click="downloadcsv"
            name="link"
            with-icon="mdi-file-excel-outline"
            :nochevron="true"
            color-icon="#0052FF"
        >
            Télécharger ma recherche
        </action>
        <v-dialog v-model="loading" width="450px">
            <v-card>
                <v-card-title class="text-h5 grey lighten-2">
                    Préparation de votre fichier Excel
                </v-card-title>
                <div class="loading-circle">
                    <v-progress-circular :size="50" :width="3" color="#0052FF" indeterminate />
                </div>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { Services } from "src/services/Services";
import { parseArrayQuery } from "../../helpers/query-formatter";

export default {
    components: {},
    props: ["annotationOptions", "insurers", "apenafs", "query", "displayedSubjects"],
    data() {
        return {
            conventions: null,
            loading: false,
        };
    },
    methods: {
        async downloadcsv() {
            this.loading = true;
            const displayedSubjectsCodes = this.displayedSubjects.map(subject => subject.code);
            const response = await Services.api.convention.getSearchablePanoramaExport({
                ...this.query,
                displayedSubjects: parseArrayQuery(displayedSubjectsCodes),
            });
            const url = window.URL.createObjectURL(
                new Blob([this.s2ab(atob(response))], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;",
                })
            );
            const a = document.createElement("a");
            a.href = url;
            a.download = `Panorama des conventions-${Services.moment(new Date()).format(
                "h-mm-DD-MM-YYYY"
            )}.xlsx`;
            document.body.appendChild(a);
            a.click();
            a.remove();
            this.loading = false;
        },
        s2ab(s) {
            var buf = new ArrayBuffer(s.length);
            var view = new Uint8Array(buf);
            for (var i = 0; i != s.length; i++) {
                view[i] = s.charCodeAt(i) & 0xff;
            }
            return buf;
        },
    },
};
</script>

<style scoped lang="sass">
.loading-circle
    height: 150px
    display: flex
    padding: 10px
    justify-content: center
    align-items: center
</style>
